export const AVAILABLE_SIDEMENU_OPTIONS = [
  'HOME',
  'FIND_JOBS',
  'MY_JOBS',
  'JOB_ALERTS',
  'MY_REFERRALS',
  'FORUM',
  'SURVEY',
  'TIMESHEETS',
  'INBOX',
  'Privacy_And_Consent',
  'HELP',
  'LOGOUT',
];
